import { i18n } from '../../i18n';
import { T_CAPTCHA_SCRIPT_URL } from '../config';
import { appendScript } from '../utils/load-script';

let cachePromise: Promise<void> | null = null;

export async function preloadTcaptchaScript() {
  cachePromise = loadTcaptchaScript().catch((err) => {
    console.error(err);
  })
    .finally(() => {
      cachePromise = null;
    });
}

export async function loadTcaptchaScript() {
  if (cachePromise) {
    await cachePromise;
  }
  try {
    if (!window.TencentCaptcha) {
      await appendScript(T_CAPTCHA_SCRIPT_URL);
    }
  } catch (error) {
    throw i18n('TCaptcha加载失败，请重试');
  }
  if (!window.TencentCaptcha) {
    throw i18n('TCaptcha获取失败，请重试');
  }
}
